import axe from '@axe-core/react';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import {
  Box,
  Button,
  Container,
  CssBaseline,
  StyledEngineProvider,
  ThemeProvider,
} from '@mui/material';
import { grey } from '@mui/material/colors';
import { SnackbarProvider } from 'notistack';
import React, { ReactChild, useContext, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import BeaconTheme from '../BeaconTheme';
import useToggle from '../hooks/useToggle';
import LaunchDarklyContext from './contexts/LaunchDarklyContext';
import UserContext from './contexts/UserContext';
import FeedbackDialog from './FeedbackDialog';
import Footer from './Footer';
import AnthologyTopBar from './TopBar/AnthologyTopBar';
import TopBar from './TopBar/TopBar';

interface IPageContainer {
  federationProvider: any;
  children: ReactChild;
}

const PageContainer = (props: IPageContainer) => {
  const user = useContext(UserContext);
  const location = useLocation();

  const [feedbackDialogOpen, toggleFeedbackDialogOpen] = useToggle();

  useEffect(() => {
    // Scroll to top on nav
    window.scrollTo(0, 0);

    //@ts-ignore
    if (window.Appcues) {
      //@ts-ignore
      window.Appcues.page();
      //@ts-ignore
      window.Appcues.identify(user.id, {
        institutionId: user.institutionId,
        institutionName: user.institutionName,
      });
    }
    if (process.env.NODE_ENV !== 'production') {
      // Log accessibility issues to the console
      axe(React, props.children, 1000, undefined, {
        exclude: ['.MuiAutocomplete-root'],
      });
    }
  }, [location]);

  return (
    <>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={BeaconTheme}>
          <CssBaseline />
          <SnackbarProvider
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            maxSnack={3}
          >
            <nav>
              <AnthologyTopBar
                user={user}
                federationProvider={props.federationProvider}
                homepage="/"
              />
              <TopBar user={user} />
            </nav>
            <main id="main-content">
              <Container
                maxWidth="xl"
                style={{ height: '100%', position: 'relative' }}
              >
                <div className="wrapper">
                  <div style={{ paddingTop: '100px' }}>
                    <Box display="flex" justifyContent="flex-end">
                      <Button
                        variant="text"
                        startIcon={
                          <InsertCommentIcon style={{ color: grey[600] }} />
                        }
                        onClick={() => toggleFeedbackDialogOpen()}
                        style={{
                          color: '#0066cc',
                          textTransform: 'none',
                          marginBottom: '5px',
                        }}
                      >
                        Send Us Your Feedback
                      </Button>
                    </Box>
                    {props.children}
                  </div>
                  <div className="push" />
                </div>
                <Footer />

                <FeedbackDialog
                  open={feedbackDialogOpen}
                  close={toggleFeedbackDialogOpen}
                />
              </Container>
            </main>
          </SnackbarProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </>
  );
};

export default PageContainer;
